/**
 * Получить обработчик ошибки по наименованию класса исключения.
 * Handler выполнится только если наименование класса пойманного исключение соответствует переданному.
 * Иначе исключение пробрасывается.
 *
 * @param errorName наименование класса исключения.
 * @param handler обработчик исключения.
 */
export const getExceptionHandler = <T extends Error>(
    errorName: string,
    handler: (error: T) => void,
) => {
    return (error: T) => {
        if (error.name === errorName) {
            handler(error);
        } else {
            throw error;
        }
    };
};
